import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { styled, Tooltip as Tooltip$1 } from '@mui/material';
import { useRef, useState, useCallback, useEffect } from 'react';

function Tooltip(_a) {
    var { showOnlyOnEllipsis } = _a, props = __rest(_a, ["showOnlyOnEllipsis"]);
    const ref = useRef(null);
    const [hasEllipsis, setHasEllipsis] = useState(false);
    const shouldDisableTooltip = showOnlyOnEllipsis && !hasEllipsis;
    const handleRef = useCallback((element) => {
        if (!ref.current) {
            ref.current = element;
        }
        if (showOnlyOnEllipsis && element) {
            const { offsetWidth, scrollWidth } = element;
            setHasEllipsis(offsetWidth < scrollWidth);
        }
    }, [showOnlyOnEllipsis]);
    useEffect(() => {
        addEventListener("resize", () => handleRef(ref.current));
        return () => removeEventListener("resize", () => handleRef(ref.current));
    }, [handleRef]);
    return (jsx(EllipsisTooltip, Object.assign({ "$showOnlyOnEllipsis": showOnlyOnEllipsis, PopperProps: POPPER_PROPS_SETTINGS, disableFocusListener: shouldDisableTooltip, disableHoverListener: shouldDisableTooltip, disableTouchListener: shouldDisableTooltip, ref: handleRef }, props)));
}
const POPPER_PROPS_SETTINGS = {
    modifiers: [
        {
            name: "flip",
            enabled: true,
            options: {
                fallbackPlacements: ["left", "bottom", "top", "right"],
                altBoundary: false,
                rootBoundary: "viewport",
            },
        },
    ],
};
const EllipsisTooltip = styled(Tooltip$1)(({ $showOnlyOnEllipsis }) => (Object.assign({}, ($showOnlyOnEllipsis && {
    display: "block",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
}))));

export { Tooltip };
//# sourceMappingURL=Tooltip.js.map
